import React from "react";
import Footer from '../src/component/footer'
import RouterLink from "../src/cofig/RouterLink"

 let App=()=> {





  
  return(
    <>
<RouterLink />
<Footer />
    </>

  )


}



export default App;